import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Link from 'next/link';
import Typography from '../../common-components/component-library/text/Typography';
import { colors, spacing } from '../../utils/styleguide';

type LinkItems = Array<{
  id: string;
  slug?: string;
  title: string;
}>;

const LinkItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]}px;
`;

const ArticleLinkListStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]}px;
  padding-left: ${spacing[3]}px;
`;

export default function ArticleLinkList({
  items,
  linkPrefix,
}: {
  items?: LinkItems;
  isInitiative?: boolean;
  linkPrefix: string;
}) {
  if (!items?.length) return null;

  return (
    <ArticleLinkListStyles>
      {items?.map((item) => {
        const { slug, id, title } = item;
        if (!slug) return null;
        return (
          <LinkItem key={id}>
            •
            <Link href={`${linkPrefix}/${slug}`} passHref legacyBehavior>
              <Typography
                variant="subtitle"
                tag="a"
                css={css`
                  color: ${colors.blackPrimary};
                  cursor: pointer;
                  display: flex;
                  text-decoration: underline;
                  text-underline-offset: 4px;
                  text-decoration-thickness: 1px;
                  :hover {
                    color: ${colors.green300};
                  }
                `}
              >
                {title}
              </Typography>
            </Link>
          </LinkItem>
        );
      })}
    </ArticleLinkListStyles>
  );
}
